import React from 'react';
import { CTABand } from '../../components/CTABand';
export function NorthvilleFinalCTA() {
  return <CTABand headline={`Ready to Find Your Class or Program?`} copy={`Join the many families from Northville who train at Storm Taekwondo. Start with a trial class and explore the full lineup of classes and programs.`} data-id="element-2603" />;
}